import React from 'react';
import { useOrButton } from './or-button.hook';
import './or-button.css';

export type OrButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'label';
export type OrButtonTheme = 'default' | 'social';
export type OrButtonSize = 'xs' | 'sm' | 'md' | 'lg';

export interface OrButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  fullWidth?: boolean;
  isLoading?: boolean;
  leftSlot?: React.ReactNode;
  rightSlot?: React.ReactNode;
  size?: OrButtonSize;
  theme?: OrButtonTheme;
  variant?: OrButtonVariant;
}

export function OrButton({
  children,
  className,
  disabled,
  fullWidth,
  isLoading = false,
  leftSlot,
  rightSlot,
  size,
  theme,
  type = 'button',
  variant,
  ...rest
}: OrButtonProps): React.ReactElement {
  const { buttonClassName } = useOrButton({ className, fullWidth, size, theme, variant });

  return (
    <button className={buttonClassName} disabled={disabled || isLoading} type={type} {...rest}>
      {isLoading ? <span className="or-button__spinner" aria-hidden="true" /> : leftSlot}
      <span className="or-button__label">{children}</span>
      {!isLoading ? rightSlot : null}
    </button>
  );
}
